import React from 'react';
import './main.less';

import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import RichTextField from '../../../shared/form-elements/rich-text';
import LangSelect from '../../../shared/lang/select';
import TextArea from '../../../shared/form-elements/textarea';

const isEverad = process.env.CPA_ENV === 'everad';

function Editor({ intl, can, languages, landingLanguages, ...props }) {
	const lang = props.params.lang;

	return (
		<div className='form-container lang-rules-editor'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit rule')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div className='lang-rules-editor-lang'>
						<Field
							name='campaign_lang'
							disabled={!!lang}
							component={LangSelectField}
							defaultLang='en'
							showLabel={false}
							langs={landingLanguages}
							intl={intl}
						/>
					</div>
					{languages.map((lang, index) => (
						<div
							className='lang-rules-editor-rule'
							key={index}
						>
							<Field
								name={`rules_${lang.id}`}
								placeholder={intl(`Rules (${lang.id} translation)`)}
								component={isEverad ? RichTextField : TextArea}
							/>
						</div>
					))}
					<div className='banners-buttons'>
						{can('edit') && (
							<button className='ui-btn ui-btn-primary'>
								{intl('Save')}
							</button>
						)}
						<Link
							className='ui-btn ui-btn-cancel'
							to='/offer-location-rules/lang-rules'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function LangSelectField(props) {
	const { touched, error } = props.meta;

	return (
		<div className='form-element-select'>
			<div className='select__label'>
				{props.intl('Campaign language')}
			</div>
			<LangSelect
				{...props.input}
				defaultLang={props.defaultLang}
				disabled={props.disabled}
				langs={props.langs}
				isSingle
			/>
			{touched && error && (
				<span className='lang-select-error'>
					{error}
				</span>
			)}
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		landingLanguages: selectors.getLandingLanguages(state),
		languages: selectors.getLanguages(state),
		can: selectors.getCan(state)
	};
}

function validate(values) {
	const errors = {};
	const notEmptyFields = ['rules_en', 'rules_ru'];

	notEmptyFields.forEach((field) => !values[field] && (errors[field] = 'Should not be empty'));

	if (!values.campaign_lang || !values.campaign_lang[0]) {
		errors['campaign_lang'] = 'Please, indicate language';
	}

	return errors;
}

const Main = reduxForm({ form: `${namespace}Form`, validate, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/lang-rules/edit/main.js